import ReserveCancelCollectionsTable from './ReserveCancelCollectionsTable.vue'

export { ReserveCancelCollectionsTable }
export default ReserveCancelCollectionsTable
